import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { setAddChildbirthOBToTimeline } from '../store/quickActions.actions'
import { resetState } from '../../procedures/childbirthOB/store/childbirthOB.actions'
import { addChildbirthOBItem } from '../../timeline/store/timeline.actions'
import { ChildbirthOBConstants } from '../../procedures/childbirthOB/store/childbirthOB.constants'

export function* saveChildbirthQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addChildbirthOBToTimeline } = quickActionsObject
  if (addChildbirthOBToTimeline) {
    yield put(addChildbirthOBItem())
    yield put(setAddChildbirthOBToTimeline(false))
    yield put(resetState())
  }
}

export function* saveChildbirthQuickActionTimeLineRowSaga() {
  yield takeLatest([ChildbirthOBConstants.SET_ADD_TO_TIMELINE], saveChildbirthQuickActionTimeLineRow)
}
